import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '@pc/header';
import { IconComponent } from '@pc/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressStepperComponent } from '@pc/progress-stepper';
import { CdkStep } from '@angular/cdk/stepper';
import { HeaderModel } from './header.model';
import { EntityBannerComponent } from '@pc/entity-banner';
import { expand } from '@pc/animations';

@Component({
  selector: 'pc-app-header',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    IconComponent,
    TranslateModule,
    ProgressStepperComponent,
    CdkStep,
    EntityBannerComponent
  ],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [expand]
})
export class AppHeaderComponent {
  public headerData = input.required<HeaderModel | null>();
  public isAgentProcess = input.required<boolean>();
  public agentName = input.required<string | null>();
  public entityBannerText = input.required<string | null>();
  public disclaimerName = input<string>('');
  public isNavigationLocked = input(false);
  public isShowDisclaimer = input(true);
  public hData = computed(() => {
    return this.headerData() as HeaderModel;
  });
  public isDesktop = computed(() => {
    return this.hData().isDesktop();
  });
  public accStmtClick = output();
  public hideDisclaimer = signal(false);
  public showDisclaimer = computed(() => this.isShowDisclaimer() && !this.hideDisclaimer());

  hideDisclaimerHandler(): void {
    this.hideDisclaimer.set(true);
  }
}
